import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { Badge } from '@consta/uikit/Badge';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { QuestionTypeEnum } from 'src/utils/enum';
import { ISummaryTableItem } from 'src/redux/features/analytic/types';
import { TextField } from '@consta/uikit/TextField';
import { Table } from '@consta/uikit/Table';

export interface IAnalyticsAnswersInfoCartProps {
  question: ISummaryTableItem;
  number: number;
}

interface NewQuestType {
  titlePoint: string;
  name: string;
  id: number;
  is_answer_correct: boolean;
  question_answer_id?: number;
  cnt?: number;
}

const cx = cn.bind(styles);

const AnalyticsAnswersInfoCart: React.FC<IAnalyticsAnswersInfoCartProps> = ({
  question,
  number,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [filtMultiRating, setFiltMultiRating] = useState<NewQuestType[] | []>(
    [],
  );

  useEffect(() => {
    const newQuest = question.answers.map((item) => {
      const splitName = item.name?.split('-оценка');
      return {
        ...item,
        titlePoint: splitName.length > 0 ? splitName[0] : '',
        name: splitName.length > 1 ? splitName[1] : '',
      };
    });
    const filteredNewQuest: NewQuestType[] = [];

    newQuest?.filter((item: NewQuestType) => {
      if (
        !filteredNewQuest?.some(
          (el: NewQuestType) => el.titlePoint === item.titlePoint,
        )
      ) {
        filteredNewQuest.push(item);
      }
    });
    setFiltMultiRating(filteredNewQuest);
  }, [question]);

  const columnTable: any = [
    {
      title: (
        <Text className={cx('AnalyticsAnswersInfoCart__columnText')} size="xs">
          Оценка
        </Text>
      ),
      accessor: 'title',
      align: 'center',
    },
    ...Array.from(Array(question?.rating)).map((_, i) => {
      return {
        title: (
          <Text
            className={cx('AnalyticsAnswersInfoCart__columnText')}
            size="xs"
          >
            {i + 1}
          </Text>
        ),
        accessor: i + 1,
        align: 'center',
      };
    }),
  ];

  const rows = useMemo(() => {
    if (question.type === QuestionTypeEnum.POINT_RATING) {
      return [
        {
          id: 'oneRating',
          title: '',
          ...Object.fromEntries(
            Array.from(Array(question?.rating)).map((_, i) => {
              const questNumber = question.answers.find(
                (answ) => +answ.name === i + 1,
              );
              return [
                i + 1,
                <Text key={i} size="xs">
                  {questNumber ? questNumber.cnt : 0}
                </Text>,
              ];
            }),
          ),
        },
      ];
    } else if (question.type === QuestionTypeEnum.MULTIPLE_POINT_RATING) {
      const newQuest = question.answers.map((item) => {
        const splitName = item.name?.split('-оценка');
        return {
          ...item,
          titlePoint: splitName.length > 0 ? splitName[0] : '',
          name: splitName.length > 1 ? splitName[1] : '',
        };
      });
      return filtMultiRating
        ?.slice(0, isOpen ? question.answers.length : 3)
        ?.map((quest, index) => ({
          id: String(index),
          title: quest.titlePoint,
          ...Object.fromEntries(
            Array.from(Array(question?.rating)).map((rate, i) => {
              const questNumb = newQuest.find((answ) => {
                if (
                  answ.titlePoint === quest.titlePoint &&
                  +answ.name === i + 1
                ) {
                  return answ;
                }
              });
              return [
                i + 1,
                <Text key={i} size="xs">
                  {questNumb ? questNumb.cnt : 0}
                </Text>,
              ];
            }),
          ),
        }));
    }
  }, [filtMultiRating, isOpen, question]);

  const typeElement: React.ReactElement = useMemo(() => {
    if (question.type === QuestionTypeEnum.SELF_SELECT)
      return (
        <Badge
          label="ОТВЕТ ОТ ПОЛЬЗОВАТЕЛЯ"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__self')}
        />
      );
    if (question.type === QuestionTypeEnum.SINGLE_SELECT)
      return (
        <Badge
          label="ОДИНОЧНЫЙ ВЫБОР"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__single')}
        />
      );
    if (question.type === QuestionTypeEnum.MULTIPLE_SELECT)
      return (
        <Badge
          label="МНОЖЕСТВЕННЫЙ ВЫБОР"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__multiple')}
        />
      );
    if (question.type === QuestionTypeEnum.SINGLE_AND_SELF)
      return (
        <Badge
          label="ОДИНОЧНЫЙ ВЫБОР + СВОЙ ВАРИАНТ"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__singleSelf')}
        />
      );
    if (question.type === QuestionTypeEnum.MULTIPLE_AND_SELF)
      return (
        <Badge
          label="МНОЖЕСТВЕННЫЙ ВЫБОР + СВОЙ ВАРИАНТ"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__multipleSelf')}
        />
      );
    if (question.type === QuestionTypeEnum.MULTIPLE_AND_SELF)
      return (
        <Badge
          label="МНОЖЕСТВЕННЫЙ ВЫБОР + СВОЙ ВАРИАНТ"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__multipleSelf')}
        />
      );
    if (question.type === QuestionTypeEnum.MULTIPLE_POINT_RATING)
      return (
        <Badge
          label="множественная балльная оценка"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__multiRating')}
        />
      );
    if (question.type === QuestionTypeEnum.POINT_RATING)
      return (
        <Badge
          label="балльная оценка"
          size="s"
          className={cx('AnalyticsAnswersInfoCart__rating')}
        />
      );
    return <div />;
  }, [question]);

  const content = useMemo(() => {
    if (
      question.type !== QuestionTypeEnum.POINT_RATING &&
      question.type !== QuestionTypeEnum.MULTIPLE_POINT_RATING
    ) {
      return question.answers
        .slice(0, isOpen ? question.answers.length : 3)
        .map((answer, index) => (
          <div key={index} className={cx('AnalyticsAnswersInfoCart__answer')}>
            {answer?.id ? (
              <div className={cx('AnalyticsAnswersInfoCart__answerSelf')}>
                <Text>{index + 1}.</Text>
                <Text>{answer?.name}</Text>
              </div>
            ) : (
              <div className={cx('AnalyticsAnswersInfoCart__answerSelf')}>
                <Text>{index + 1}. </Text>
                <TextField disabled value={answer.name} width="full" size="s" />
              </div>
            )}

            <Text weight="semibold">{answer.cnt}</Text>
          </div>
        ));
    } else if (question.type === QuestionTypeEnum.POINT_RATING) {
      return (
        <Table
          className={cx('AnalyticsAnswersInfoCart__table')}
          zebraStriped="odd"
          size="s"
          columns={columnTable}
          rows={rows}
          borderBetweenRows={true}
          verticalAlign="center"
        />
      );
    } else if (question.type === QuestionTypeEnum.MULTIPLE_POINT_RATING) {
      return (
        <Table
          className={cx('AnalyticsAnswersInfoCart__table')}
          zebraStriped="odd"
          size="s"
          columns={columnTable}
          rows={rows}
          borderBetweenRows={true}
          verticalAlign="center"
        />
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, question, rows]);

  return (
    <div className={cx('AnalyticsAnswersInfoCart')}>
      <div>
        <div className={cx('AnalyticsAnswersInfoCart__container')}>
          <div className={cx('AnalyticsAnswersInfoCart__header')}>
            <div className={cx('AnalyticsAnswersInfoCart__label')}>
              {question.answers?.length > 3 &&
                question.type !== QuestionTypeEnum.POINT_RATING &&
                (question.type === QuestionTypeEnum.MULTIPLE_POINT_RATING
                  ? filtMultiRating.length > 3
                  : true) && (
                  <IconArrowDown
                    onClick={() => setIsOpen(!isOpen)}
                    view="secondary"
                    className={cx('AnalyticsAnswersInfoCart__arrow', {
                      AnalyticsAnswersInfoCart__arrow_active: isOpen,
                    })}
                  />
                )}
              <Text
                className={cx({
                  AnalyticsAnswersInfoCart__padding:
                    question.answers?.length < 4 ||
                    question.type === QuestionTypeEnum.POINT_RATING ||
                    (question.type === QuestionTypeEnum.MULTIPLE_POINT_RATING &&
                      filtMultiRating.length <= 3),
                })}
              >
                № {number}
              </Text>
            </div>
            <div className={cx('AnalyticsAnswersInfoCart__status')}>
              {typeElement}
            </div>
          </div>
          <div
            className={cx(
              'AnalyticsAnswersInfoCart__question',
              'AnalyticsAnswersInfoCart__padding',
            )}
          >
            {question?.name}
          </div>
          <div className={cx('AnalyticsAnswersInfoCart__content')}>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsAnswersInfoCart;
